module.exports = __webpack_public_path__ + "static/dance-e932fde6b4b61b0470f5c62375e84b2d.gif";